import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createAptosNetworkProvider } from '../utils/createAptosNetworkProvider';

export const registerAptosNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  // If the Aptos network provider builder is already registered, return.
  if (networkProviderBuilderRegistry.get().get('APTOS')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: createAptosNetworkProvider,
    chain: 'APTOS',
  });
};
